import WithLearnService from "./with-learn-service";

export default WithLearnService;